$(function () {
    var $slide = $('.home-slide .swiper-container');

    if(!$slide.length) return

    var mySwiper = new Swiper ($slide, {
        autoplay: {
            delay: 7000,
        },
        navigation: {
            prevEl: '.slide-button-prev',
            nextEl: '.slide-button-next'
        }
    })
});